export const LOADED = 'transcriptions/LOADED'

export const GET_REQUEST = 'transcriptions/GET_REQUEST'
export const GET_SUCCESS = 'transcriptions/GET_SUCCESS'
export const GET_FAILURE = 'transcriptions/GET_FAILURE'

export const CREATE_REQUEST = 'transcriptions/CREATE_REQUEST'
export const CREATE_SUCCESS = 'transcriptions/CREATE_SUCCESS'
export const CREATE_FAILURE = 'transcriptions/CREATE_FAILURE'

export const UPDATE_REQUEST = 'transcriptions/UPDATE_REQUEST'
export const UPDATE_SUCCESS = 'transcriptions/UPDATE_SUCCESS'
export const UPDATE_FAILURE = 'transcriptions/UPDATE_FAILURE'

export const DEL_REQUEST = 'transcriptions/DEL_REQUEST'
export const DEL_SUCCESS = 'transcriptions/DEL_SUCCESS'
export const DEL_FAILURE = 'transcriptions/DEL_FAILURE'



// WEBPACK FOOTER //
// ./src/redux/transcriptions/action-types.js